document.addEventListener('DOMContentLoaded', () => {
  const contextForm = document.querySelector('form#ContactForm');

  if (contextForm) {
    contextForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      e.stopPropagation();  
      e.stopImmediatePropagation();

      const emailField = document.querySelector('#ContactForm-email');
      if(emailField.value.trim() === '') {
        emailField.value = 'missing-email@careline365.co.uk'
      }
      
      contextForm.submit();
    })
  }
})